import { Box, Card, CardContent } from '@mui/material';
import { LenderDetails } from 'src/e2e-redesign/mock-data/MockLenderDetails';
import { OrgSettingsI } from 'src/interfaces/e2e-state.interfaces';
import { LenderProductDetailsI } from 'src/interfaces/lenders.interfaces';
import { StoreSettingsI } from 'src/interfaces/store-settings.interfaces';
import { SNAP_ID } from 'src/utils/bread-e2e-constants';

import SingleLogo from '../SingleLogo';

interface CardProps {
  lender: LenderDetails;
  storeSettings?: StoreSettingsI;
  orgSettings?: OrgSettingsI;
}
export enum SnapProductsE {
  'ric' = 'ric',
  'lto' = 'lto',
  'loan' = 'loan',
}
const getSnapProductDetails = (
  lender: LenderDetails,
  product_type: SnapProductsE,
): LenderProductDetailsI[] => {
  if (product_type) {
    switch (product_type) {
      case SnapProductsE.loan:
        return [
          {
            name: 'Snap Loan Product',
            html: `<ul>
                           <li>Apply in minutes, get a decision in seconds</li>
                           <li>Get more time to pay for what you need</li>
                           <li>Approval amounts range from $300 to $5,000 and depend on underwriting qualification criteria</li>
                           <li>Snap takes a fresh approach to creditworthiness</li>
                       </ul>
                    <p>Loans made by Quill Bank</p>`,
            industries: [],
            franchises: [],
            laas: [],
            global_variable_values: {},
            is_default: true
          },
        ];
      // Cant use this because it is slightly different
      // const baseHtml = lender.product_details[0].html.replace(
      //   /Loans made by Quill Bank\s*$/g,
      //   '',
      // );
      //
      // const cloned = `${baseHtml}
      //
      // Loans made by Quill Bank`;
      //
      // return [{ html: cloned }];
      default:
        return lender.product_details;
    }
  }
  return lender.product_details;
};
export const replaceLenderDetailsBasedOnProduct = (
  lender: LenderDetails,
  settings?: {
    storeSettings?: StoreSettingsI;
    orgSettings?: OrgSettingsI;
  },
): LenderDetails => {
  const storeSettings = settings?.storeSettings;
  const orgSettings = settings?.orgSettings;
  if (lender) {
    switch (lender.lender_id) {
      case SNAP_ID:
        if (storeSettings?.global_variables?.product_type) {
          const storeUpdate = getSnapProductDetails(lender, storeSettings?.global_variables?.product_type);
          lender.product_details = storeUpdate;
        } else if (orgSettings?.global_variables?.product_type) {
          const orgUpdate = getSnapProductDetails(lender, orgSettings?.global_variables?.product_type);
          lender.product_details = orgUpdate;
        } else {
          return lender;
        }
    }
  }
  return lender;
};
const ProviderDetailsCard = ({ lender, storeSettings, orgSettings }: CardProps) => {
  const settings = {
    storeSettings,
    orgSettings,
  };
  // TODO - clean up and make note in rewrite of this situation
  replaceLenderDetailsBasedOnProduct(lender, settings);
  return (
    <Card sx={{ height: '100%', padding: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        <SingleLogo image={{ src: lender.image_path, alt: lender.name }} />
      </Box>
      <CardContent>
        {lender.product_details.map((detail, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html: detail.html }} />
        ))}
      </CardContent>
    </Card>
  );
};

export default ProviderDetailsCard;
